export default __webpack_public_path__ + "static/media/group_5172.dd0c6951.png";